/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box} from '@mui/material';
import {EntryQueryHandlerMap, SectionQueryHandlerMap} from 'graphql/operations';
import {cloneDeep, get} from 'lodash';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import React, {ReactNode} from 'react';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import PageWrapper from '~/components/wrapper/molecules/page-wrapper';
import {
  DATA_PAGE_PATHS,
  MAPPING_LOCALES,
  PLACEHOLDER_IMG,
  REVALIDATE_TIME,
  LIST_ID_GAME_POPULAR,
} from '~/constants';
import {GAME_LISTING_SOURCE, NEWS_LISTING_SOURCE, GLOBAL_TYPE} from '~/constants/content-map-type';
import {getGloablByType} from '~/utils/global-operations';
import {getLitTypePopular} from '~/providers/get-list-type-popular';
import {getListGameByQueryValue} from '~/pages/games/get-list-game-by-query-value';
import {ssrGetBySlug} from '~/graphql/operations/page/page-query.generated';
import {usePageSetting} from '~/providers/page-context.provider';
import {
  convertToSlug,
  dateArithmetic,
  handleConvertToLocaleContentful,
  handleRenderPrice,
  handleReturnSubtitleLanguage,
  handleTranslateNews,
  isDateLagerThanOneMonthFromNow,
} from '~/utils';
// import {handleFormatDataMastheadPrices} from '~/utils/button-functions';
import * as Types from '../../graphql/types';
import getListGameNoReleaseDate from './get-list-game_no_release_date';
import getListNewsGame from './get-list-news-games';
import RenderNextLink from '~/components/wrapper/atoms/render-next-link';
import getListGameForNav from '~/components/wrapper/organisms/navigation-bar/get-list-game';
import {getLitGameByIdBlock} from '~/components/wrapper/organisms/navigation-bar/get-list-game-by-id';
import {LIST_ID_GAME_OUR_PICK} from '~/constants';
import {useFacebookPosts} from '~/hooks/useFacebookPosts';

const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

export type getPageOptions = {
  slug: string;
  preview: boolean;
};

export type IItemSupport = {
  __typename: string;
  type?: string;
  title: boolean;
  richTextDescription: string;
  configuration?: any;
  questionsCollection: {
    items: IItemQuestion[];
  };
};

export type IItemQuestion = {
  __typename: string;
  question: string;
  answer: ReactNode | any;
};

export type IItemBreadcrumb = {
  href: string;
};

export type PageProps = {
  locale: string;
  bcProductReference: any;
  data: any;
  listNewsGame: Types.NewsCollection;
  listTagsColor: any;

  listComingSoonGames: any;
  dataTranslation: any;
  host: any;
};

export const handleFormatTablist = (
  isFeatured?: boolean,
  isPreOrder?: boolean,
  isSoldOut?: boolean,
  highest_discount?: number,
  isNew?: boolean,
  dataTranslation?: any
) => {
  const listTabs: any = {
    isFeatured: {title: dataTranslation?.['estore-products-tab-featured'], color: '#00B0B8'},
    isPreOrder: {title: dataTranslation?.['estore-products-tab-pre-order'], color: '#0169B2 '},
    isSoldOut: {title: dataTranslation?.['estore-products-tab-sold-out'], color: '#737373  '},
    isNew: {title: dataTranslation?.['estore-products-tab-new'], color: '#F5B700'},
    discount: {
      title: `${dataTranslation?.['news-tag-sale']}`,
      color: '#DF4662',
    },
    // discount: {
    //   title: `${dataTranslation['estore-product-sale-up-to' || '']} ${Math.floor(
    //     highest_discount || 0
    //   )}% ${dataTranslation?.['estore-products-tab-off']}`,
    //   color: '#DF4662',
    // },
  };
  const result: any = [];
  if (isFeatured) {
    result.push(listTabs.isFeatured);
  }
  if (isPreOrder) {
    result.push(listTabs.isPreOrder);
  }
  if (highest_discount) {
    result.push(listTabs.discount);
  }
  if (isSoldOut) {
    result.push(listTabs.isSoldOut);
  }
  if (isNew) {
    result.push(listTabs.isNew);
  }
  return result.splice(0, 2);
};

export const handleFormatPlatforms = (listPlatform: any[]): string[] => {
  if (!listPlatform.length) return listPlatform;

  const newListPlatform: any[] = [];
  const arrayPlatform = listPlatform.map(item => {
    const newItem = item.title?.trim()?.toLowerCase();
    if (
      newItem === 'nintendo 3ds' ||
      newItem === 'nintendo switch' ||
      newItem === 'nintendo 3ds xl'
    ) {
      return 'Nintendo';
    }
    if (
      newItem === 'playstation 4' ||
      newItem === 'playstation 5' ||
      newItem === 'ps4' ||
      newItem === 'ps5'
    ) {
      return 'PlayStation';
    }
    if (
      newItem === 'xbox 360' ||
      newItem === 'xbox one' ||
      newItem === 'xbox series x' ||
      newItem === 'xbox series x|s' ||
      newItem === 'xbox series s/x' ||
      newItem === 'xbox series s'
    ) {
      return 'XBOX';
    }
    if (newItem === 'steam' || newItem === 'pc') {
      return 'Steam';
    }
    return newItem;
  });
  arrayPlatform.map(item => {
    if (!newListPlatform.includes(item)) {
      newListPlatform.push(item);
    }
  });
  const data: any = [];
  arrayPlatform.map(item => {
    if (item === 'PlayStation') {
      data[0] = item;
    } else if (item === 'Nintendo') {
      data[1] = item;
    } else if (item === 'XBOX') {
      data[2] = item;
    } else if (item === 'Steam') {
      data[3] = item;
    } else {
      data.push(item);
    }
  });
  return data;
};

export const handleFormatProducts = (product: any[], dataTranslation?: any, locale?: any) => {
  if (!product?.length) {
    return [];
  }

  return product.map((item: any) => {
    return {
      id: item?.id,
      tabList: handleFormatTablist(
        item?.isFeatured,
        item?.isPreOrder,
        item?.isSoldOut,
        item?.highest_discount,
        isDateLagerThanOneMonthFromNow(parseInt(item?.releaseDate) * 1000),
        dataTranslation || {}
      ),
      isMerchandise: item?.isMerchandise ?? false,
      listIcon: item?.isMerchandise ? [] : handleFormatPlatforms(item?.platforms || []),
      href: item?.isMerchandise
        ? `/store/merchandise/${convertToSlug(item?.title || '')}`
        : `/store/games/${convertToSlug(item?.title || '')}`,
      nextLink: (href: string, child: ReactNode) => (
        <RenderNextLink href={`${href}`} child={child} />
      ),
      hrefImg: item?.mainImage || PLACEHOLDER_IMG,
      titleGame: item?.title,
      language:
        item?.isMerchandise || !item?.language
          ? ''
          : handleReturnSubtitleLanguage(`${item?.language}`.split(','), locale),
      isDLC: item?.isDLC || false,
      titleDLC: 'DLC',
      titleFrom: dataTranslation?.['label-from'] || '',
      price: `${handleRenderPrice(item?.sale_price || '00', null, locale)}`,
      priceOld:
        !item?.highest_discount || item?.sale_price === item?.default_price
          ? ''
          : `${handleRenderPrice(item?.default_price || '00', null, locale)}`,
      titleSale: item?.highest_discount
        ? `${item?.highest_discount}% ${dataTranslation['estore-products-tab-off']} `
        : '',
    };
  });
};

export const handleSortAddress = (listAddress: any[]) => {
  if (!listAddress?.length) return [];

  return listAddress.sort((a: any, b: any) => {
    if (a.id > b.id) {
      return -1;
    }
    return 1;
  });
};

const Page: React.FC<PageProps> = ({
  data,
  bcProductReference = {},
  listNewsGame,
  listComingSoonGames,
  host,
}) => {
  const {posts: listFacebookPost} = useFacebookPosts();
  const page = data?.pageCollection?.items[0];
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const listTagsColor = globalData?.listTagsColor ?? [];

  if (!page) {
    return <ErrorPage statusCode={404} />;
  }

  const block: Array<any> = [page.sectionCollection?.items, page.seoStandard].filter(
    block => !!block
  );
  const blockCopy = cloneDeep(block);
  blockCopy[0]?.map((section: any, idx: number) => {
    if (blockCopy[0][idx].blocksCollection?.items[0]) {
      blockCopy[0][idx].blocksCollection.items[0] = {
        ...blockCopy[0][idx].blocksCollection.items[0],
        dataTranslation: dataTranslation,
      };
    }
    if (section?.blocksCollection?.items[0]?.__typename === 'Mashthead') {
      if (bcProductReference && section.blocksCollection.items[0].content) {
        section.blocksCollection.items[0].content.bcProductReference = bcProductReference;
      }
    }

    if (section?.blocksCollection?.items[0]?.dataSource === 'Latest news & events') {
      section.blocksCollection.items[0].__typename = 'HomePageGamesListing';
      section.blocksCollection.items[0].listItemCollection = handleTranslateNews(
        listNewsGame.items,
        dataTranslation
      );
      section.blocksCollection.items[0].listTags = listTagsColor;
      section.blocksCollection.items[0].removePadding = !listComingSoonGames.length ? true : false;
    }

    if (section?.blocksCollection?.items[0]?.dataSource === NEWS_LISTING_SOURCE.seaFacebook) {
      section.blocksCollection.items[0].listItemCollection.items = listFacebookPost;
      section.blocksCollection.items[0].__typename = 'HomePageNewListing';
      section.blocksCollection.items[0].listTags = listTagsColor;
      section.blocksCollection.items[0].host = host;
    }

    if (section?.blocksCollection?.items[0]?.dataSource === GAME_LISTING_SOURCE.comingSoonGames) {
      section.blocksCollection.items[0].listItemCollection.items = listComingSoonGames;
    }
  });

  return (
    <PageWrapper theme={page.theme as any}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <BlockRenderer block={[...blockCopy]} />
      </Box>
    </PageWrapper>
  );
};

export type GetPageDataResult = {
  data: PageProps['data'] & {globalData?: any};
};

export async function getCommonDataOnServer(locale: string) {
  const promises: [
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getLitTypePopular>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>
  ] = [
    getGloablByType(handleConvertToLocaleContentful(locale as string), GLOBAL_TYPE.newsFilterColor),
    getGloablByType(handleConvertToLocaleContentful('sea'), GLOBAL_TYPE.translation),
    getGloablByType(handleConvertToLocaleContentful(locale as string), GLOBAL_TYPE.translation),
    getLitTypePopular(
      LIST_ID_GAME_POPULAR[handleConvertToLocaleContentful(locale as string)] ??
        LIST_ID_GAME_POPULAR['en-sg'],
      handleConvertToLocaleContentful(locale as string)
    ),
    getGloablByType(handleConvertToLocaleContentful(locale as string), GLOBAL_TYPE.subscribe),
    getGloablByType(handleConvertToLocaleContentful(locale as string), GLOBAL_TYPE.country),
  ];

  const [
    listTagsColor,
    dataTranslationEN,
    dataTranslation,
    dataPopularTrending,
    dataSubscribe,
    country,
  ] = await Promise.all(promises);

  const listGamePopular: any = (
    (await getListGameByQueryValue(
      handleConvertToLocaleContentful(locale as string),
      dataPopularTrending
    )) ?? []
  )
    .map(item => {
      return {
        title: item?.title ?? '',
        slug: item?.slug ?? '',
      };
    })
    .filter(item => !!item.slug);

  return {
    listTagsColor: listTagsColor ?? [],
    dataTranslation: [dataTranslation, dataTranslationEN],
    dataPopularTrending: (listGamePopular as any) ?? [],
    dataSubscribe: dataSubscribe,
    listCountry: country?.country || [],
    listPhoneNumberCode: country?.phone_number_code || [],
  };
}

export async function getPageData(
  options: getPageOptions,
  ctx: GetServerSidePropsContext
): Promise<GetPageDataResult> {
  const {
    props: {data},
  } = await ssrGetBySlug.getServerPage(
    {
      variables: {
        ...options,
        locale: handleConvertToLocaleContentful((ctx.locale as string) ?? ''),
      },
    },
    {ssrContext: ctx}
  );
  const globalData = await getCommonDataOnServer(ctx.locale as string);
  const result: any = cloneDeep({data});
  if (result.data) {
    result.data.globalData = globalData;
  }
  if (data.pageCollection?.items[0]) {
    const page = data.pageCollection?.items[0];
    if (page) {
      const queries: Array<ReturnType<typeof SectionQueryHandlerMap['handler']>> = [];

      (page.sectionCollection?.items || []).forEach(item =>
        queries.push(
          SectionQueryHandlerMap['handler'](
            {
              variables: {
                id: item?.sys.id as string,
                locale: handleConvertToLocaleContentful((ctx.locale as string) ?? ''),
              },
            },
            {ssrContext: ctx}
          ).then(async result => {
            result = cloneDeep(result);
            const {
              props: {data},
            } = result;

            let blocks = await Promise.all(
              (data.section?.blocksCollection?.items || []).map(async block => {
                const handlerMap = EntryQueryHandlerMap.find(
                  item => item.__typename === block?.__typename
                );

                if (handlerMap) {
                  const {
                    props: {data},
                  } = await handlerMap.handler(
                    {
                      variables: {
                        id: get(block, 'sys.id') as string,
                        locale: handleConvertToLocaleContentful((ctx.locale as string) ?? ''),
                      },
                    },
                    {ssrContext: ctx}
                  );

                  if (block?.__typename) {
                    return Object.values(data)[0];
                  }
                }
              })
            );
            blocks = blocks.filter(b => !!b);

            if (data.section?.blocksCollection?.items) {
              data.section.blocksCollection.items = [];
              data.section.blocksCollection.items.push(
                ...(blocks as typeof data.section.blocksCollection.items)
              );
            }
            return result;
          })
        )
      );
      const sections = await Promise.all(queries);
      if (result.data.pageCollection?.items[0]?.sectionCollection?.items) {
        result.data.pageCollection.items[0].sectionCollection.items = [];
      }

      sections.forEach(section => {
        const {
          props: {data},
        } = section;
        //@ts-ignore
        result.data.pageCollection?.items[0]?.sectionCollection?.items.push(data['section']);
      });
    }
  }

  return result;
}

export async function getStaticPaths() {
  type SlugParam = {
    params: {
      slug: string[];
      locale?: string;
    };
  };

  const returnSlugs: SlugParam[] = [];
  for (let i = 0; i < MAPPING_LOCALES.length; i++) {
    for (let y = 0; y < DATA_PAGE_PATHS.length; y++) {
      const param: SlugParam = {
        params: {
          slug: [DATA_PAGE_PATHS[y]],
          locale: MAPPING_LOCALES[i].value,
        },
      };
      returnSlugs.push(param);
    }
  }
  return {paths: returnSlugs, fallback: 'blocking'};
}

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const today = new Date();
  const slug = String(ctx?.params?.slug ?? '/');
  const CONTENTFUL_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  const options: getPageOptions = {
    slug,
    preview,
  };

  const promises: [
    ReturnType<typeof getListNewsGame>,
    ReturnType<typeof getListGameNoReleaseDate>
  ] = [
    getListNewsGame(handleConvertToLocaleContentful(ctx.locale as string)),
    getListGameNoReleaseDate(
      handleConvertToLocaleContentful((ctx.locale as string) ?? ''),
      0,
      8,
      {},
      Types.GameOrder.ReleaseDateDesc,
      {
        from: today.toISOString(),
        to: dateArithmetic(today, 6).toISOString(),
      }
    ),
  ];

  const [listNewsGame, listComingSoonGames] = await Promise.all(promises);
  const locale = handleConvertToLocaleContentful(ctx.locale as string) ?? '';

  // Run page data, common data, AND nav data in parallel for best server performance
  const [{data}, [navGameLatest, navOurPicks]] = await Promise.all([
    getPageData(options, ctx),
    Promise.all([
      getListGameForNav(locale, 0, 6, {}, 'releaseDate_DESC'),
      getLitGameByIdBlock(LIST_ID_GAME_OUR_PICK[locale] ?? LIST_ID_GAME_OUR_PICK['en-sg'], locale),
    ]),
  ]);

  // Nav data: pre-fetched server-side to avoid client-side gameCollection calls
  const navData = {
    gameLatest: (navGameLatest?.items ?? [])
      .map(item => {
        return {
          title: item?.title ?? '',
          slug: item?.slug ?? '',
        };
      })
      .filter(item => !!item.slug),
    ourPicks: (navOurPicks ?? [])
      .map(item => {
        return {
          title: item?.title ?? '',
          slug: item?.slug ?? '',
          mainThumbnailImg: {
            media: {
              url: item?.mainThumbnailImg?.media?.url ?? '',
            },
          },
        };
      })
      .filter(item => !!item.slug),
  };

  const listNewsGameData: any = listNewsGame?.items?.length
    ? {
        items: listNewsGame.items.map(item => {
          return {
            title: item?.title,
            slug: item?.slug,
            publishDate: item?.publishDate,
            shortDescription: item?.shortDescription,
            customTags: item?.customTags,
            mainImage: item?.mainImage,
          };
        }),
      }
    : listNewsGame;

  const page = data?.pageCollection?.items[0];
  const sectionCollection = data.pageCollection?.items[0]?.sectionCollection?.items.map(
    (items: any) => {
      const typeName = items.blocksCollection?.items?.[0]?.__typename;
      const type = items.blocksCollection?.items?.[0]?.type;
      const dataSource = items.blocksCollection?.items?.[0]?.dataSource;
      const blocksCollection = items.blocksCollection?.items?.[0];

      const sys = {
        __typename: items?.__typename,
        theme: items?.theme,
        noPadding: items?.noPadding,
      };

      if (typeName === 'Mashthead') {
        return {
          ...sys,
          blocksCollection: {
            __typename: blocksCollection?.__typename ?? null,
            items: [
              {
                __typename: typeName,
                content: {
                  __typename: blocksCollection?.content?.__typename ?? null,
                  bcProductReference: blocksCollection?.content?.bcProductReference ?? '',
                  description: blocksCollection?.content?.description ?? '',
                  mastheadBackgroundImage: {
                    media: {
                      url: blocksCollection?.content?.mastheadBackgroundImage?.media?.url ?? '',
                    },
                  },
                  mastheadGalleryCollection: {
                    items: (blocksCollection?.content?.mastheadGalleryCollection?.items ?? []).map(
                      (item: any) => {
                        return {
                          internalName: item?.internalName ?? null,
                          videoEmbed: item?.videoEmbed ?? null,
                          media: item?.media ?? null,
                          url: item?.url ?? null,
                        };
                      }
                    ),
                  },
                  overviewTitle: blocksCollection?.content?.overviewTitle ?? '',
                  platform: blocksCollection?.content?.platform ?? [],
                  slug: blocksCollection?.content?.slug ?? '',
                  title: blocksCollection?.content?.title ?? '',
                },
              },
            ],
          },
        };
      }
      if (typeName === 'ExploreNewUniverse') {
        return {
          ...sys,
          blocksCollection: {
            items: [
              {
                __typename: typeName,
                title: blocksCollection?.title ?? '',
                brandListCollection: {
                  items: blocksCollection?.brandListCollection?.items.map((item: any) => {
                    return {
                      title: item?.title ?? null,
                      videoId: item?.videoId ?? null,
                      mediaImage: item?.mediaImage ?? null,
                      mediaVideo: item?.mediaVideo ?? null,
                      gameListCollection: {
                        items: [
                          {
                            listItemCollection: {
                              items: (
                                item?.gameListCollection?.items[0]?.listItemCollection?.items ?? []
                              ).map((game: any) => {
                                return {
                                  slug: game?.slug ?? '',
                                  title: game?.title ?? '',
                                  mastheadBackgroundImage: {
                                    media: {
                                      url: game?.mastheadBackgroundImage?.media?.url ?? '',
                                    },
                                  },
                                  mainThumbnailImg: {
                                    media: {
                                      url: game?.mainThumbnailImg?.media?.url ?? '',
                                    },
                                  },
                                };
                              }),
                            },
                          },
                        ],
                      },
                    };
                  }),
                },
              },
            ],
          },
        };
      }
      if (typeName === 'GamesListing' && type === 'HorizontalScrollingContainerMediaGallery') {
        return {
          ...sys,
          blocksCollection: {
            items: [
              {
                __typename: blocksCollection?.__typename ?? null,
                dataSource: blocksCollection.dataSource ?? null,
                description: blocksCollection.description ?? null,
                openNewTab: blocksCollection.openNewTab ?? false,
                title: blocksCollection.title ?? null,
                type,
                listItemCollection: {
                  __typename: blocksCollection?.listItemCollection?.__typename,
                  items: (blocksCollection?.listItemCollection?.items ?? []).map((item: any) => {
                    return {
                      title: item?.title ?? null,
                      slug: item?.slug ?? null,
                      carouselKeyartGameThumbnailImage: {
                        media: {
                          url: item?.carouselKeyartGameThumbnailImage?.media?.url ?? '',
                        },
                      },
                      mastheadBackgroundImage: {
                        media: {
                          url: item?.mastheadBackgroundImage?.media?.url ?? '',
                        },
                      },
                    };
                  }),
                },
              },
            ],
          },
        };
      }
      if (typeName === 'GamesListing' && type === 'ThumbnailCardWithPublicDate') {
        return {
          ...sys,
          blocksCollection: {
            items: [
              {
                __typename: blocksCollection?.__typename ?? null,
                dataSource: blocksCollection.dataSource ?? null,
                description: blocksCollection.description ?? null,
                openNewTab: blocksCollection.openNewTab ?? false,
                title: blocksCollection.title ?? null,
                type,
                listItemCollection: {
                  __typename: blocksCollection?.listItemCollection?.__typename,
                  items: (blocksCollection?.listItemCollection?.items ?? []).map((item: any) => {
                    return {
                      title: item?.title ?? null,
                      slug: item?.slug ?? null,
                      mainThumbnailImg: {
                        media: {
                          url: item?.mainThumbnailImg?.media?.url ?? '',
                        },
                      },
                      platform: item?.platform ?? [],
                      releaseDate: item?.releaseDate ?? null,
                    };
                  }),
                },
              },
            ],
          },
        };
      }
      if (typeName === 'NewsListing' && dataSource === 'Latest news & events') {
        return {
          ...sys,
          blocksCollection: {
            items: [
              {
                dataSource,
                openNewTab: blocksCollection?.openNewTab ?? false,
                title: blocksCollection?.title ?? null,
                seeAllText: blocksCollection?.seeAllText ?? null,
                stepScroll: blocksCollection?.stepScroll ?? null,
                type,
                typeName,
                listItemCollection: {
                  items: (blocksCollection?.listItemCollection?.items ?? []).map((item: any) => {
                    return {
                      title: item?.title ?? null,
                      slug: item?.slug ?? null,
                      mainThumbnailImg: {
                        media: {
                          url: item?.mainThumbnailImg?.media?.url ?? '',
                        },
                      },
                    };
                  }),
                },
              },
            ],
          },
        };
      }
      if (typeName === 'NewsListing' && dataSource === 'SEA Facebook') {
        return {
          ...sys,
          blocksCollection: {
            items: [
              {
                __typename: blocksCollection?.__typename ?? null,
                dataSource,
                openNewTab: blocksCollection?.openNewTab ?? false,
                title: blocksCollection?.title ?? null,
                seeAllText: blocksCollection?.seeAllText ?? null,
                stepScroll: blocksCollection?.stepScroll ?? null,
                type,
                typeName,
                listItemCollection: {
                  items: [],
                },
              },
            ],
          },
        };
      }

      return items;
    }
  );

  if (data.pageCollection?.items?.[0]?.sectionCollection?.items) {
    data.pageCollection.items[0].sectionCollection.items = sectionCollection ?? [];
  }
  const __typename =
    data?.pageCollection?.items?.[0]?.sectionCollection?.items?.[0]?.blocksCollection?.items?.[0]
      ?.__typename;
  const isGlobalPage = __typename === 'Global';

  if (!page) {
    return {
      redirect: {
        destination: `/${ctx.locale}/404`,
        permanent: false,
      },
    };
  } else {
    return {
      props: {
        bcProductReference: {},
        data,
        listNewsGame: isGlobalPage ? [] : listNewsGameData,
        listComingSoonGames: isGlobalPage ? [] : listComingSoonGames?.items ?? [],
        host: CONTENTFUL_SITE_URL,
        navData,
      },
      revalidate: REVALIDATE_TIME,
    };
  }
};

export default Page;
